import React, { useState, Fragment, useCallback, useContext } from 'react'
import axios from 'axios'
import { Button, Layer, Box, Text, Form, FormField, TextInput, TextArea, Grommet } from 'grommet';
import { Mail, Map } from 'grommet-icons'
import styled from 'styled-components' 
import { NoltButton } from 'components/common/Nolt'
import { AuthorizedUserContext } from 'components/common/AuthorizedUser'
import { css } from 'styled-components'
import { addNotification } from 'AppEntry'

const FORMCARRY_SECRET = process.env.REACT_APP_FORMCARRY_SECRET

const customExtend = {
      textArea: {
          extend: css`
            ${props => 'min-height: 150px;'}
          `
      },
      layer: {
          zIndex: "100"
      }
      
  };


const DrawerLayer = (props) => { 
    const { onClose } = props 
    
    const [show, setShow] = React.useState();
    const [emailValue, setEmailValue] = React.useState('');
    const [textAreaValue, setTextAreaValue] = React.useState('');
    
    const handleContactForm = () => {    
        const email = emailValue || props.userData.email; //may come from one of two places
        axios.post(
            `https://formcarry.com/s/${FORMCARRY_SECRET}`,
            { email: email, message: textAreaValue },
            { headers: {"Accept": "application/json"} }    
        ).then((response) => {
            setShow(false)
            addNotification('Success!', 'An email was sent with your feeback.', 'success');
          })
          .catch((error) => addNotification('Error!', error.message, 'error'));
    }

    return(
        <Fragment>
        <Layer full='vertical' modal={true} plain={true} position='right' >
            <Box background='brand' fill='vertical'
                pad={{ left: 'small', right: 'small' }} 
            >
                <Button  hoverIndicator={{ background: 'light-5' }} >
                    <Box pad={{ bottom: 'small', horizontal: 'medium', top: 'medium' }}>
                        <Text 
                            alignSelf='end' 
                            onClick={onClose}
                            primary={true} 
                            size='large'
                            weight='bold' 
                        >X</Text>
                    </Box>
                </Button>
                <Text 
                    margin={{ bottom: "small" }}
                    size='large'
                >Need help? Have a suggestion?</Text>
                        <NoltButton />
                {   [ 
                        // { href: 'https://07044696.nolt.io/', icon: <Map />, label: 'Make a suggestion'}, 
                        { href: 'mailto:feedback@zaaas.io', icon: <Mail />, label: 'Send us email'}, 
                        //{ label: 'Chat with us'},
                        { href: '', label: 'Chat with us (coming soon)'},
                    ].map((buttonPropValues, index) => (
                        <Button
                            hoverIndicator={{ background: 'light-5' }}
                            icon={buttonPropValues.icon}
                            label={buttonPropValues.label}
                            key={buttonPropValues.label}
                            margin={{ bottom: 'xsmall' }}
                            onClick={buttonPropValues.href ? () => setShow(true) : null}
                        />
                    ))
                }
            </Box>
        </Layer>
        {show && (
            <Grommet theme={customExtend}>
                <Layer
                modal={true}
                responsive={true}
                margin="large"
                onEsc={() => setShow(false)}
                onClickOutside={() => setShow(false)}
                >
                    <Box pad="large" responsive={true}>
                        <Form>
                            { props.userData === null ? 
                                <FormField name="email">
                                    <TextInput
                                        placeholder="your@email.com"
                                        focusIndicator={false}
                                        plain
                                        value={emailValue}
                                        onChange={event => setEmailValue(event.target.value)}
                                    />
                                </FormField> 
                            : null
                            }
                            
                                <FormField name="feeback" pad={true}>
                                    <TextArea
                                        resize={false}
                                        placeholder="How can we improve?"
                                        fill={true}
                                        value={textAreaValue}
                                        onChange={event => setTextAreaValue(event.target.value)}
                                    />
                                </FormField>
                            <Button margin="medium" label="close" onClick={() => setShow(false)} />
                            <Button margin="medium" onClick={() => handleContactForm()} primary label="Submit" />
                        </Form>
                    </Box>
                </Layer>
            </Grommet>
        )}
        </Fragment>
  )
}

// TODO: Consider whether to use GrommetThemeExtender rather than styled-components
const OpenButtonContainer = styled.div`
    position: fixed;
    right: -24px;
    top:50%;
    transform: rotate(-90deg);
    &:hover {
        cursor: pointer;
    }
`; 

const Drawer = () => { 
    const [state, setState] = useState({ open: false }) 
    const userData = useContext(AuthorizedUserContext)

    return(
        <OpenButtonContainer>
            {
                state.open ? 
                <DrawerLayer userData={userData} onClose={() => setState({ open: false })} />
            : 
                <Box 
                    align='end' 
                    background='brand' 
                    direction='row' 
                    gap='medium' 
                    onClick={ () => setState({ open: true })}
                    pad={{ left: 'small', right: 'small', top: 'xxsmall'}}
                    //round='medium'
                >
                    <Text color='light-1'>feedback</Text>
                </Box>
            }
        </OpenButtonContainer>
    )
}

export default Drawer